<template>
  <div class="ios-root">
    <!-- Top utility bar (desktop) -->
    <div class="ios-utility hidden-sm-and-down">
      <v-app-bar height="40" flat color="transparent" class="ios-bar ios-utility-inner">
        <v-btn text small href="mailto:info@grupoficenca.com" class="ios-link">
          <i class="fas fa-envelope pr-2 ios-icon-xs"></i>
          <strong>info@grupoficenca.com</strong>
        </v-btn>

        <v-btn text small href="https://www.waze.com/live-map/directions?to=ll.9.960029%2C-84.111993" target="_blank" class="ios-link">
          <i class="fas fa-location-arrow pr-2 ios-icon-xs"></i>
          <strong>Dirección</strong>
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn icon text target="_blank" small :href="`https://facebook.com/grupo.ficenca`" class="ios-icon-btn">
          <i class="fab fa-facebook-f"></i>
        </v-btn>
        <v-btn icon text target="_blank" small :href="`https://instagram.com/grupo.ficenca`" class="ios-icon-btn">
          <i class="fab fa-instagram"></i>
        </v-btn>
        <v-btn icon text target="_blank" small :href="`https://www.linkedin.com/company/ficencacr/`" class="ios-icon-btn">
          <i class="fab fa-linkedin-in"></i>
        </v-btn>
        <v-btn icon text target="_blank" small :href="`https://api.whatsapp.com/send?phone=50670188845`" class="ios-icon-btn">
          <i class="fab fa-whatsapp"></i>
        </v-btn>
      </v-app-bar>
    </div>

    <!-- Top utility bar (mobile) -->
    <div class="ios-utility hidden-md-and-up">
      <v-app-bar height="40" flat color="transparent" class="ios-bar ios-utility-inner">
        <div class="ios-utility-center">
          <v-btn icon text small href="mailto:info@grupoficenca.com" class="ios-icon-btn">
            <i class="fas fa-envelope"></i>
          </v-btn>
          <v-btn icon text small href="https://www.waze.com/live-map/directions?to=ll.9.960029%2C-84.111993" target="_blank" class="ios-icon-btn">
            <i class="fas fa-location-arrow"></i>
          </v-btn>
          <v-btn icon text small target="_blank" :href="`https://facebook.com/grupo.ficenca`" class="ios-icon-btn">
            <i class="fab fa-facebook-f"></i>
          </v-btn>
          <v-btn icon text small target="_blank" :href="`https://instagram.com/grupo.ficenca`" class="ios-icon-btn">
            <i class="fab fa-instagram"></i>
          </v-btn>
          <v-btn icon text small target="_blank" :href="`https://www.linkedin.com/company/ficencacr/`" class="ios-icon-btn">
            <i class="fab fa-linkedin-in"></i>
          </v-btn>
          <v-btn icon text small target="_blank" :href="`https://api.whatsapp.com/send?phone=50670188845`" class="ios-icon-btn">
            <i class="fab fa-whatsapp"></i>
          </v-btn>
        </div>
      </v-app-bar>
    </div>

    <!-- Main navbar -->
    <v-app-bar height="88" flat color="white" class="ios-mainbar">
      <div class="ios-container">
        <div class="ios-brand">
          <img src="@/assets/logo.png" width="200" alt="Ficenca" />
          <img class="ml-2 hidden-sm-and-down" src="@/assets/logofiac.png" width="100" alt="FIAC" />
        </div>

        <v-spacer></v-spacer>

        <!-- Desktop menu -->
        <div class="ios-menu hidden-sm-and-down">
          <v-btn text rounded class="ios-nav-btn" @click="irPagina('/')">Inicio</v-btn>

          <!-- Catálogos -->
          <v-menu open-on-hover offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text rounded class="ios-nav-btn" v-bind="attrs" v-on="on">Catálogos</v-btn>
            </template>
            <v-list class="ios-menu-list">
              <v-list-item v-for="(item, index) in catalogos" :key="index" @click="irPagina2(item.link)">
                <v-list-item-title class="ios-menu-item">{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Servicios -->
          <v-menu open-on-hover offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text rounded class="ios-nav-btn" v-bind="attrs" v-on="on">Servicios</v-btn>
            </template>
            <v-list class="ios-menu-list">
              <v-list-item v-for="(item, index) in items" :key="index" @click="irPagina(item.link)">
                <v-list-item-title class="ios-menu-item">{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Equipos -->
          <v-menu open-on-hover offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text rounded class="ios-nav-btn" v-bind="attrs" v-on="on">Equipos</v-btn>
            </template>
            <v-list class="ios-menu-list">
              <v-list-item v-for="(item, index) in itemsE" :key="index" @click="irPagina(item.link)">
                <v-list-item-title class="ios-menu-item">{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-badge content="nuevo" overlap color="#0a84ff" class="ios-badge">
            <v-btn text rounded class="ios-nav-btn" @click="irPagina('/Proyectos')">Proyectos</v-btn>
          </v-badge>
        </div>

        <!-- Mobile burger -->
        <v-btn icon text class="hidden-md-and-up" @click="nav = !nav" aria-label="Abrir menú">
          <i class="fas fa-bars ios-burger"></i>
        </v-btn>

        <!-- CTA -->
        <v-btn text rounded href="/Contactenos" class="ios-cta hidden-sm-and-down">
          Contáctenos
        </v-btn>
      </div>
    </v-app-bar>

    <!-- Drawer móvil -->
    <v-navigation-drawer v-model="nav" app width="300" class="ios-drawer">
      <img src="@/assets/logo.png" width="200" class="ios-drawer-logo" alt="Ficenca">

      <v-list dense>
        <v-list-item v-for="(item, i) in bars" :key="i" @click="irPagina(item.link)">
          <v-list-item-content>
            <v-list-item-title class="ios-drawer-item">{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Servicios -->
      <v-list dense>
        <v-list-group no-action sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="ios-drawer-section">Servicios</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-for="(title, i) in items" :key="i" @click="irPagina(title.link)">
            <v-list-item-title class="ios-drawer-subitem">{{ title.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <!-- Catálogos -->
      <v-list dense>
        <v-list-group no-action sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="ios-drawer-section">Catálogos</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-for="(title, i) in catalogos" :key="i" @click="irPagina2(title.link)">
            <v-list-item-title class="ios-drawer-subitem">{{ title.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <!-- Equipos -->
      <v-list dense>
        <v-list-group no-action sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="ios-drawer-section">Equipos</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-for="(title, i) in itemsE" :key="i" @click="irPagina(title.link)">
            <v-list-item-title class="ios-drawer-subitem">{{ title.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-btn text class="ios-drawer-cta" @click="irPagina('/Contactenos')">Contáctenos</v-btn>

      <div class="ios-drawer-brand">
        <img src="@/assets/logofiac.png" width="100" alt="FIAC">
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data(){
    return {
      catalogos: [
        { title: 'Compresores de Tornillo', link: 'https://grupoficenca.com/pdf/compresores-de-tornillo-2025.pdf'},
        { title: 'Compresores de Pistón', link: 'https://grupoficenca.com/pdf/compresores-de-piston-2025.pdf'},
        { title: 'Compresores Libres de Aceite', link: 'https://grupoficenca.com/pdf/compresores-libre-de-aceites.pdf'},
      ],
      items: [
        { title: 'Servicios Generales', link: '/Servicios'},
        { title: 'Variadores de frecuencia', link: '/variadores-de-frecuencia'},
        { title: 'Controlador Inteligente', link: '/controlador-Inteligente'},
        { title: 'Monitoreo Remoto', link: '/monitoreo-Remoto'},
        { title: 'Alquiler de Equipos', link: '/alquiler-de-equipos'},
      ],
      itemsE: [
        { title: 'Tienda General', link: '/Equipos'},
        { title: 'Compresores de Tornillo', link: '/Categoria?cat=tornillo'},
        { title: 'Compresores de Pistón', link: '/Categoria?cat=piston'},
        { title: 'Secadores TDRY', link: '/Categoria?cat=secadore'},
        { title: 'Filtro de línea', link: '/Categoria?cat=filtros'},
        { title: 'Tanques / Reservorio', link: '/Categoria?cat=tanque'},
        { title: 'Variadores de Frecuencia', link: '/Categoria?cat=variadores'},
        { title: 'Repuestos', link: '/Categoria?cat=accesorio'},
      ],
      nav: false,
      bars: [{ text: "Inicio", link: "/" }]
    }
  },
  methods:{
    irPagina(e){ window.open(e, "_self") },
    irPagina2(e){ window.open(e, "_blank") }
  }
}
</script>

<style scoped>
*{
    letter-spacing: 0 !important;
    text-transform: none !important;
}
.ios-badge {
  z-index: 10000;
}
/* Tipografía iOS */
.ios-root, *:not(.fa):not(.fas):not(.fab):not(.far) {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Arial, sans-serif;
}

/* Font Awesome fix */
.fa, .fas, .far { font-family: "Font Awesome 5 Free" !important; }
.fab { font-family: "Font Awesome 5 Brands" !important; }

/* Utility bar */
.ios-utility {
  background: rgba(236,236,236,0.54);
  backdrop-filter: saturate(180%) blur(10px);
}
.ios-utility-inner { width: 90%; margin: 0 auto; }
.ios-utility-center { margin: 0 auto; display: flex; gap: 8px; }

/* Icon buttons */
.ios-link { font-size: 12.5px; text-transform: none; color: #222 !important; }
.ios-icon-xs { font-size: 11px; }
.ios-icon-btn { color: #22354b !important; font-size: 14px; }

/* Main bar */
.ios-mainbar { border-bottom: 1px solid #efefef; }
.ios-container { width: 90%; margin: 0 auto; display: flex; align-items: center; }
.ios-menu { display: flex; gap: 6px; }
.ios-nav-btn { text-transform: 0 !important; color: #22354b !important; font-weight: 600; border-radius: 12px; letter-spacing: 0 !important;}
.ios-cta { background:#165198 !important; color:white !important; border-radius:16px; font-weight:800; }
.ios-burger { font-size:28px; color:#165198; }

/* Drawer */
.ios-drawer-logo { margin:36px auto 12px; display:block; }
.ios-drawer-item { font-weight:600; color:#22354b; }
.ios-drawer-section { font-weight:700; color:#22354b; }
.ios-drawer-subitem { color:#22354b; }
.ios-drawer-cta { width:90%; margin:14px auto; background:#165198 !important; color:#fff !important; font-weight:800; border-radius:14px; }
.ios-drawer-brand { position:absolute; bottom:24px; left:50%; transform:translateX(-50%); }
</style>
